import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-ext";
var Instructions = /** @class */ (function (_super) {
    tslib_1.__extends(Instructions, _super);
    function Instructions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    tslib_1.__decorate([
        Prop({ type: String, default: "" }),
        tslib_1.__metadata("design:type", String)
    ], Instructions.prototype, "titleKey", void 0);
    tslib_1.__decorate([
        Prop({ type: String, default: "" }),
        tslib_1.__metadata("design:type", String)
    ], Instructions.prototype, "property", void 0);
    Instructions = tslib_1.__decorate([
        Component
    ], Instructions);
    return Instructions;
}(Vue));
export default Instructions;
